/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 *
 *
 * 1 = MonthDayYearTime
 *
 * 2 = MonthDayYear
 *
 * 3 = DayMonthYearTime
 *
 * 4 = DayMonthYear
 *
 * 5 = MonthYear
 *
 * 6 = Year
 * @format int32
 */
export enum AIReportDateFormat {
  MonthDayYearTime = 1,
  MonthDayYear = 2,
  DayMonthYearTime = 3,
  DayMonthYear = 4,
  MonthYear = 5,
  Year = 6,
}

/**
 *
 *
 * 1 = AIObject
 *
 * 2 = PrefixAIObject
 *
 * 3 = AIObjectDate
 *
 * 4 = PrefixAIObjectDate
 * @format int32
 */
export enum AIReportNameTemplate {
  AIObject = 1,
  PrefixAIObject = 2,
  AIObjectDate = 3,
  PrefixAIObjectDate = 4,
}

export interface AIReportPublishNameTemplateModel {
  /**
   *
   *
   * 1 = AIObject
   *
   * 2 = PrefixAIObject
   *
   * 3 = AIObjectDate
   *
   * 4 = PrefixAIObjectDate
   */
  Template?: AIReportNameTemplate
  /**
   *
   *
   * 1 = MonthDayYearTime
   *
   * 2 = MonthDayYear
   *
   * 3 = DayMonthYearTime
   *
   * 4 = DayMonthYear
   *
   * 5 = MonthYear
   *
   * 6 = Year
   */
  DateFormat?: AIReportDateFormat
  Prefix: string
}

export interface ApiErrorResponse {
  Error: Error
}

export interface BillingSettingsModel {
  IsBillingEnabled: boolean
  /** @format double */
  SessionPrice?: number | null
  /** @format int32 */
  RecordingTimeLimit?: number | null
  /** @format int32 */
  WarnUserRemainTime?: number | null
  /** @format int32 */
  UploadVideoStorageLimit?: number | null
  /** @format int32 */
  NumberCustomVideosAllowed?: number | null
  /**
   *
   *
   * 1 = SessionWithExpiration
   */
  ProductType: ProductType
  /** @format int32 */
  ExpirationInDays?: number | null
  HidePrice: boolean
  RecordingTimeLimitUnlimited: boolean
  WarnUserRemainTimeUnlimited: boolean
  UploadVideoStorageLimitUnlimited: boolean
  NumberCustomVideosAllowedUnlimited: boolean
}

export interface CorporationCreateOrUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 256
   */
  Name: string
  /** @maxLength 1024 */
  Description?: string | null
  TenantIds: number[]
  AdminUserIds: string[]
}

export interface CorporationResponse {
  /** @format int32 */
  Id: number
  /** @format date-time */
  CreatedOn: string
  Name: string
  Description?: string | null
  Tenants: TenantViewModel[]
  AdminUserIds: string[]
}

export interface CreateTenantRequest {
  /** @maxLength 256 */
  Name: string
  /**
   * @minLength 1
   * @maxLength 256
   */
  Subdomain: string
  Config: string
  /** @format int32 */
  EnvId?: number | null
}

export interface CustomUserProperty {
  type: string
  /** @format int32 */
  maxLength?: number | null
  /** @format int32 */
  minLength?: number | null
}

export interface Error {
  /** @format int32 */
  Code: number
  /** @minLength 1 */
  Message: string
  Details?: string | null
}

export interface FtpSettings {
  FtpHost: string
  FtpUserName: string
  FtpPassword: string
}

export interface FtpSettingsResponse {
  FtpHost: string
  FtpUserName: string
}

export interface NewTenantDefaultConfigurationsResponse {
  StorageGroupName?: string | null
  TenantConfigurationSourceTenantName?: string | null
  TenantConfigurationSourceTenantSubdomain?: string | null
}

/**
 *
 *
 * 0 = TopLeft
 *
 * 1 = BottomRight
 * @format int32
 */
export enum OverlayPosition {
  TopLeft = 0,
  BottomRight = 1,
}

/**
 *
 *
 * 1 = SessionWithExpiration
 * @format int32
 */
export enum ProductType {
  SessionWithExpiration = 1,
}

export interface SessionApprovalSettingsModel {
  /** @format int32 */
  SingleSessionActivationsLimit?: number | null
  /** @format int32 */
  UserSessionCreationLimit?: number | null
  SingleSessionActivationsLimitUnlimited: boolean
  UserSessionCreationLimitUnlimited: boolean
  /** @format int32 */
  UserSessionCreatedNumberTimes?: number | null
  ContentCreationRestricted: boolean
  ContentActivationRestricted: boolean
}

export interface StorageGroupViewModel {
  /** @format int32 */
  Id: number
  Name: string
}

export interface TenantConfig {
  introImageUrl: string
  introImageTextColor: string
  customIframeNomenclature: string
  customIframeUrl: string
  mobilePrimaryColor: string
  mobileBackgroundUrl: string
  isBillingEnabled: boolean
  isCustomIframeEnabled: boolean
  IsDetectLicensePlate: boolean
  isUploadCustomVideo: boolean
  homeBanner: string
  mission: string
  loginColor: string
  homeTextColor: string
  loginBackgroundColor: string
  bullets: string[]
  bannerLink: string
  isSessionApprovalEnabled: string
  isUploadCsvReport: boolean
  IsUploadZipImages: boolean
  showMenuGeosearch: boolean
  showGoogleButton: boolean
  showAppleButton: boolean
  showNokiaButton: boolean
  showEricssonButton: boolean
  showTmobileButton: boolean
  showImmucorButton: boolean
  isOfflineAvailable: boolean
  videoBridgeRegions: VideoBridgeRegion[]
  showSwitchToAttachedFormDialog: boolean
  isSessionSharingEnabled: boolean
  isSessionPublishingEnabled: boolean
  isChatTranslationEnabled: boolean
  isFormsAndUsersTabCollapsed: boolean
  isProModeAvailable: boolean
  isSessionReviewingEnabled: boolean
  isBulkCopyEnabled: boolean
  showMenuAnalytics: boolean
  createFolderButtonColor: string
  exportButtonColor: string
  addButtionColor: string
  mainSelectedTextColor: string
  mainTextColor: string
  mainBanner: string
  notificationColor: string
  mainBGColor: string
  isInSessionReviewEnabled: boolean
  showTabletsAssignation: boolean
  isLocalRecordingEnabled: boolean
  isCloudRecordingEnabled: boolean
  isPowerBiEnabled: boolean
  showBentleyModel: boolean
  /** @format int32 */
  singleSessionActivationsLimit?: number | null
  /** @format int32 */
  userSessionCreationLimit?: number | null
  subdomain: string
  userTitle: string
  showPageInfoOverlay: boolean
  showSessionNameInOverlay: boolean
  /**
   *
   *
   * 0 = TopLeft
   *
   * 1 = BottomRight
   */
  pageInfoOverlayPosition: OverlayPosition
  showExportFormToPdfButton: boolean
  sessionsNavbarTitle: string
  showPdfRecieversPopup: boolean
  showImageRecieversPopup: boolean
  showVideobridgeRegionDropdown: boolean
  isDetectObjects: boolean
  isConditionsEnabled: boolean
  isActivityDataReportsEnabled: boolean
  isLastActivityDataReportsEnabled: boolean
  isActionsOverUsersReportsEnabled: boolean
  isFormAnswersReportsEnabled: boolean
  isAllSessionsDataReportsEnabled: boolean
  isCheckInCheckOutReportsEnabled: boolean
  showMenuAI: boolean
  showFormUsers: boolean
  isControlInfoEnabled: boolean
  show360View: boolean
  show3dModel: boolean
  showPredictionService: boolean
  isGalleryExpansionEnabled: boolean
  showBentleyAnalyticsReport: boolean
  isDetectText: boolean
  isChatSpeechToTextEnabled: boolean
  isRecordingEnabled: boolean
  isAlertOwnerAvailable: boolean
  isAnswersAiApproveEnabled: boolean
  isAiAutoAnswerEnabled: boolean
  is3DModelCreationLimitEnabled: boolean
  isPageTagsDetectionEnabled: boolean
  isMobileTrackingEnabled: boolean
  isTrackingMapEnabled: boolean
  isMobileFormViewSwitchEnabled: boolean
  isFormAnswerConfirmationEnabled: boolean
  isFormActionEnabled: boolean
  isFormRecordEnabled: boolean
  /** @format int32 */
  sasExpirationInMinutesForContent: number
  /** @format int32 */
  sasExpirationInMinutesForReport: number
  logoUrl: string
  bannerUrl: string
  loginBackgroundImage: string
  showReminders: boolean
  openNamingFormForCopiedSessions: boolean
  showAllSessionsOriginalTenantCol: boolean
  isFormPublishingEnabled: boolean
  showHealthData: boolean
  selectedTenantsForFormPublishing: TenantViewModel[]
  selectedTenantsForSharing: TenantViewModel[]
  selectedTenantsForReviewing: TenantViewModel[]
  isContentMetadataEnabled: boolean
  isSpreadsheetsImportEnabled: boolean
  showAdvancedFilterButton: boolean
  isAIExpressionsEnabled: boolean
  isModelTrainingEnabled: boolean
  isLidarScanningEnabled: boolean
  isContentReviewAutoAcceptEnabled: boolean
  isSearchTargetContentByTenantEnabled: boolean
  mobileLogoUrl: string
  isNewMainPageViewEnabled: boolean
  isBentleyBoundingBoxManualInputEnabled: boolean
  isMergeForReviewEnabled: boolean
  contentMetadataButtonLabel: string
  contentMetadataPosition: string
  isDeviceSwitchingEnabled: boolean
  soundNotificationOnCallJoin: boolean
  showGridViewButton: boolean
  useSessionNameConvention: boolean
  isNamingConventionForReviewEnabled: boolean
  isCalendarEnabled: boolean
  isInContentReviewEnabled: boolean
  isCreatePublishFormRestrictionEnabled: boolean
  guestRoleDisplayName: string
  isSessionGuestRoleEnabled: boolean
  isViewingAdminTenantRoleEnabled: boolean
  isBillingSettingsRoleEnabled: boolean
  isSendApproveOrRejectNotificationEnabled: boolean
  sessionGuestRoleDisplayName: string
  isAccountDeletionEnabled: boolean
  isChatEnabled: boolean
  isVideoCallsEnabled: boolean
  isTenantContentsCustomDashboardsEnabled: boolean
  isAutodeskViewerEnabled: boolean
  isPointCloudModelsEnabled: boolean
  isAdvancedInviteSettingsEnabled: boolean
  isMfaEnabled: boolean
  isPageFolderAuthorizationEnabled: boolean
  formsTitle: string
  showCertificates: boolean
  isAdvancedFormSettingsEnabled: boolean
  /** @format int32 */
  certificateExpirationReminderInDays: number
  isContentLinkingEnabled: boolean
  isHospitalsLocationsEnabled: boolean
  name: string
  isSwitchTenantFeatureEnabled: boolean
  isTableRecognitionEnabled: boolean
  isContentSharingAutoAcceptEnabled: boolean
  isFormSignatureEnabled: boolean
  showSelectedOnlyOptionsExportFormToPdf: boolean
  isExportCustomFormCsvEnabled: boolean
  /** @format int32 */
  iterationDeploymentLifetimeInHours: number
  isTenantAnnouncementsEnabled: boolean
  isCallRingNotificationsEnabled: boolean
  isClassificationAnnotationsCreationEnabled: boolean
  isAIReportEnabled: boolean
  aiReportLabel: string
  aiReportPublishNameTemplate?: AIReportPublishNameTemplateModel
  isChatBotsEnabled: boolean
  useInternalFTP: boolean
  internalFTPUsername: string
  useCustomerFTP: boolean
  isIncomingContractsEnabled: boolean
  isOutgoingContractsEnabled: boolean
  selectedTenantsForContracts: TenantViewModel[]
  showQualifications: boolean
  isQualificationsForInvitesEnabled: boolean
  /** @format int32 */
  contextCaptureGigapixelLimit?: number | null
  showTimeZoneOnUploadAnswers: boolean
  isTrainingMaterialsEnabled: boolean
  trainingMaterialsTitle: string
  isUtilityInfrastructureAnalysisEnabled: boolean
  utilityInfrastructureAnalysisWorkflowId: string
  showSplatModel: boolean
  isBulkImportEnabled: boolean
  contentCreationRestricted: boolean
  isUnreadSessionChatsIndicatorEnabled: boolean
  isAIModelPublishingEnabled: boolean
  selectedTenantsForAIModelPublishing: TenantViewModel[]
  hideSystemRoles: boolean
  requireSsoLogin: boolean
  splatBackgroundRemovalEnabled: boolean
  isWebCallRingNotificationEnabled: boolean
  contentActivationRestricted: boolean
  customUserProperties: CustomUserProperty[]
  isFormValidationEnabled: boolean
  useContentCheckInRecords: boolean
  isSideNavbarEnabled: boolean
}

export interface TenantResponse {
  /** @format int32 */
  Id: number
  Name: string
  Subdomain: string
  /** @format date-time */
  CreatedOn: string
  /** @format int32 */
  CorporationId?: number | null
  CorporationName?: string | null
}

export interface TenantStorageAddModel {
  /** @format int32 */
  TenantId: number
  /** @format int32 */
  StorageGroupId: number
}

export interface TenantStorageMakeDefaultModel {
  /** @format int32 */
  TenantId: number
  /** @format int32 */
  StorageGroupId: number
}

export interface TenantStorageModel {
  /** @format int32 */
  Id: number
  /** @format int32 */
  TenantId: number
  /** @format int32 */
  StorageGroupId: number
  Name: string
  IsDefault: boolean
}

export interface TenantViewModel {
  /** @format int32 */
  Id: number
  Name: string
  Subdomain: string
}

export interface UpdateTenantModel {
  /** @maxLength 256 */
  Name: string
  /**
   * @minLength 1
   * @maxLength 256
   */
  Subdomain: string
  Config: string
}

export interface VideoBridgeRegion {
  /** @format int64 */
  id: number
  name: string
  url: string
  validUrl: boolean
  validName: boolean
}

export type UpdateTenantConfigAsyncPayload = any

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api-dev.collaborate.center/staging/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Tenant microservice api dev
 * @baseUrl https://api-dev.collaborate.center/staging/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  corporations = {
    /**
     * No description
     *
     * @tags Corporations
     * @name GetAllAsync
     * @request GET:/tenant-service/api/corporations
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<CorporationResponse[], any>({
        path: `/tenant-service/api/corporations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporations
     * @name CreateAsync
     * @request POST:/tenant-service/api/corporations
     * @secure
     */
    createAsync: (data: CorporationCreateOrUpdateRequest, params: RequestParams = {}) =>
      this.http.request<CorporationResponse[], ApiErrorResponse | void>({
        path: `/tenant-service/api/corporations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporations
     * @name GetCurrentAsync
     * @request GET:/tenant-service/api/corporations/current
     * @secure
     */
    getCurrentAsync: (params: RequestParams = {}) =>
      this.http.request<CorporationResponse, ApiErrorResponse>({
        path: `/tenant-service/api/corporations/current`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporations
     * @name GetByIdAsync
     * @request GET:/tenant-service/api/corporations/{id}
     * @secure
     */
    getByIdAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<CorporationResponse, ApiErrorResponse>({
        path: `/tenant-service/api/corporations/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporations
     * @name UpdateAsync
     * @request PUT:/tenant-service/api/corporations/{id}
     * @secure
     */
    updateAsync: (id: number, data: CorporationCreateOrUpdateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/tenant-service/api/corporations/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporations
     * @name DeleteAsync
     * @request DELETE:/tenant-service/api/corporations/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/tenant-service/api/corporations/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  storageGroups = {
    /**
     * No description
     *
     * @tags StorageGroups
     * @name GetAllAsync
     * @request GET:/tenant-service/api/StorageGroups/all
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<StorageGroupViewModel[], any>({
        path: `/tenant-service/api/StorageGroups/all`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  tabeebTenantMicroservice = {
    /**
     * No description
     *
     * @tags Tabeeb.TenantMicroservice
     * @name MapTabeebHealthChecksB20
     * @request GET:/tenant-service/api/health/apim
     */
    mapTabeebHealthChecksB20: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/tenant-service/api/health/apim`,
        method: 'GET',
        ...params,
      }),
  }
  tenant = {
    /**
     * No description
     *
     * @tags Tenant
     * @name DeleteAsync
     * @request DELETE:/tenant-service/api/tenants/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/tenant-service/api/tenants/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name GetByIdAsync
     * @request GET:/tenant-service/api/tenants/{id}
     * @secure
     */
    getByIdAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<TenantViewModel, ApiErrorResponse>({
        path: `/tenant-service/api/tenants/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name GetAllAsync
     * @request GET:/tenant-service/api/tenants
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<TenantResponse[], ApiErrorResponse>({
        path: `/tenant-service/api/tenants`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name PostAsync
     * @request POST:/tenant-service/api/tenants
     * @secure
     */
    postAsync: (data: CreateTenantRequest, params: RequestParams = {}) =>
      this.http.request<TenantViewModel, ApiErrorResponse | void>({
        path: `/tenant-service/api/tenants`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name PutAsync
     * @request PUT:/tenant-service/api/tenants
     * @secure
     */
    putAsync: (data: UpdateTenantModel, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/tenant-service/api/tenants`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name GetBySubdomainAsync
     * @request GET:/tenant-service/api/tenants/{subdomain}
     * @secure
     */
    getBySubdomainAsync: (subdomain: string, params: RequestParams = {}) =>
      this.http.request<TenantViewModel, ApiErrorResponse>({
        path: `/tenant-service/api/tenants/${subdomain}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name GetAllBySubdomainAsync
     * @request GET:/tenant-service/api/tenants/getAll/{subdomain}
     * @secure
     */
    getAllBySubdomainAsync: (subdomain: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/tenant-service/api/tenants/getAll/${subdomain}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name GetDefaultConfigurationForNewTenant
     * @request GET:/tenant-service/api/tenants/default-configuration
     * @secure
     */
    getDefaultConfigurationForNewTenant: (
      query?: {
        /** @format int32 */
        EnvId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<NewTenantDefaultConfigurationsResponse, ApiErrorResponse>({
        path: `/tenant-service/api/tenants/default-configuration`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  tenantConfig = {
    /**
     * No description
     *
     * @tags TenantConfig
     * @name GetAsync
     * @request GET:/tenant-service/api/config/{subdomain}
     * @secure
     */
    getAsync: (subdomain: string, params: RequestParams = {}) =>
      this.http.request<TenantConfig, ApiErrorResponse>({
        path: `/tenant-service/api/config/${subdomain}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConfig
     * @name UpdateTenantConfigAsync
     * @request PUT:/tenant-service/api/config/{subdomain}
     * @secure
     */
    updateTenantConfigAsync: (subdomain: string, data: UpdateTenantConfigAsyncPayload, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/tenant-service/api/config/${subdomain}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConfig
     * @name GetAdminSessionApprovalSettingsAsync
     * @request GET:/tenant-service/api/config/admin/sessionApprovalSettings
     * @secure
     */
    getAdminSessionApprovalSettingsAsync: (params: RequestParams = {}) =>
      this.http.request<SessionApprovalSettingsModel, ApiErrorResponse>({
        path: `/tenant-service/api/config/admin/sessionApprovalSettings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConfig
     * @name UpdateSessionApprovalSettingsAsync
     * @request PUT:/tenant-service/api/config/admin/sessionApprovalSettings
     * @secure
     */
    updateSessionApprovalSettingsAsync: (data: SessionApprovalSettingsModel, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/tenant-service/api/config/admin/sessionApprovalSettings`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConfig
     * @name GetBillingSettingsAsync
     * @request GET:/tenant-service/api/config/billingsettings
     * @secure
     */
    getBillingSettingsAsync: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/tenant-service/api/config/billingsettings`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConfig
     * @name GetAdminBillingSettingsAsync
     * @request GET:/tenant-service/api/config/admin/billingsettings
     * @secure
     */
    getAdminBillingSettingsAsync: (params: RequestParams = {}) =>
      this.http.request<BillingSettingsModel, ApiErrorResponse>({
        path: `/tenant-service/api/config/admin/billingsettings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConfig
     * @name UpdateBillingSettingsAsync
     * @request PUT:/tenant-service/api/config/admin/billingsettings
     * @secure
     */
    updateBillingSettingsAsync: (data: BillingSettingsModel, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/tenant-service/api/config/admin/billingsettings`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConfig
     * @name GetFtpServerSettingsAsync
     * @request GET:/tenant-service/api/config/ftpServer/{subdomain}
     * @secure
     */
    getFtpServerSettingsAsync: (subdomain: string, params: RequestParams = {}) =>
      this.http.request<FtpSettingsResponse, ApiErrorResponse>({
        path: `/tenant-service/api/config/ftpServer/${subdomain}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConfig
     * @name UpdateFtpServerSettingsAsync
     * @request PUT:/tenant-service/api/config/ftpServer/{subdomain}
     * @secure
     */
    updateFtpServerSettingsAsync: (subdomain: string, data: FtpSettings, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/tenant-service/api/config/ftpServer/${subdomain}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConfig
     * @name RegenerateAsync
     * @request PUT:/tenant-service/api/config/ftpServer/regeneratepassword
     * @secure
     */
    regenerateAsync: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/tenant-service/api/config/ftpServer/regeneratepassword`,
        method: 'PUT',
        secure: true,
        ...params,
      }),
  }
  tenantStorages = {
    /**
     * No description
     *
     * @tags TenantStorages
     * @name GetAllAsync
     * @request GET:/tenant-service/api/tenantStorages
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<TenantStorageModel[], ApiErrorResponse>({
        path: `/tenant-service/api/tenantStorages`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantStorages
     * @name AddToTenantAsync
     * @request POST:/tenant-service/api/tenantStorages
     * @secure
     */
    addToTenantAsync: (data: TenantStorageAddModel, params: RequestParams = {}) =>
      this.http.request<TenantStorageModel, ApiErrorResponse | void>({
        path: `/tenant-service/api/tenantStorages`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantStorages
     * @name GetByTenantIdAsync
     * @request GET:/tenant-service/api/tenantStorages/{tenantId}
     * @secure
     */
    getByTenantIdAsync: (tenantId: number, params: RequestParams = {}) =>
      this.http.request<TenantStorageModel[], ApiErrorResponse>({
        path: `/tenant-service/api/tenantStorages/${tenantId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantStorages
     * @name MakeDefaultAsync
     * @request POST:/tenant-service/api/tenantStorages/default
     * @secure
     */
    makeDefaultAsync: (data: TenantStorageMakeDefaultModel, params: RequestParams = {}) =>
      this.http.request<TenantStorageModel, ApiErrorResponse | void>({
        path: `/tenant-service/api/tenantStorages/default`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantStorages
     * @name DeleteFromTenantAsync
     * @request DELETE:/tenant-service/api/tenantStorages/{id}
     * @secure
     */
    deleteFromTenantAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/tenant-service/api/tenantStorages/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  userClaimsEndpoints = {
    /**
     * No description
     *
     * @tags UserClaimsEndpoints
     * @name GetUserClaims
     * @request GET:/tenant-service/api/user-claims
     */
    getUserClaims: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/tenant-service/api/user-claims`,
        method: 'GET',
        ...params,
      }),
  }
}
